import React, { useCallback } from "react"
import { GetServerSideProps, InferGetServerSidePropsType } from "next"
import { t, Trans } from "@lingui/macro"
import * as Occupancy from "@ssc-booking/api-contracts/src/occupancy"
import getServerSidePropsWithDefaultSanityContent, {
    SanityContentProps,
} from "../../_common/getServerSidePropsWithDefaultSanityContent"
import config from "../../../pages/_app-config"
import SidebarLayout from "../../../components/SidebarLayout/SidebarLayout"
import PageTitle from "../../../components/PageTitle/PageTitle"
import ChangeGuests from "../../../components/ChangeGuests/ChangeGuests"
import InnerSectionContainer from "../../../components/InnerSectionContainer/InnerSectionContainer"
import { useECommerceMachine } from "../../_common/machines/machines-context"
import useModal from "../../../components/ModalProvider/useModal"
import { useHandleGotoWebQuoteThankYou } from "../../features/_common/hooks/use-handle-goto-webquote-thankyou"
import styles from "./guests.module.scss"

type Props = InferGetServerSidePropsType<typeof getServerSideProps>
const Guests: React.FC<React.PropsWithChildren<Props>> = ({ sanityContent }) => {
    const [state, send] = useECommerceMachine()

    const { closeModalAfterSubmit } = useModal()
    useHandleGotoWebQuoteThankYou(() => closeModalAfterSubmit("close"))

    const onGuestsChange = useCallback(
        (value: Occupancy.Occupancy) => send({ type: "CHANGE_GUESTS", guests: value }),
        [send],
    )

    return (
        <SidebarLayout sanityContent={sanityContent} activeStep="guestsV4">
            <PageTitle titleHead={t`Guest selection`} dataContentName="guests-heading" showFlowTitle>
                <Trans>Choose the number of guests</Trans>
            </PageTitle>
            <div className={styles.notReadyToBook}>
                {state.context.flowVersion.ui.suiteCategoryNotReadyToBookBanner(state)}
            </div>
            <InnerSectionContainer
                backgroundColor="white"
                dataContentName="guests-selection-section"
                wrapperClassName={styles.changeGuests}
            >
                <ChangeGuests value={state.context.guests} onChange={onGuestsChange} />
                {state.context.flowVersion.ui.vsMemberCheckbox()}
            </InnerSectionContainer>
        </SidebarLayout>
    )
}

export const getServerSideProps: GetServerSideProps<SanityContentProps<"penaltiesModalContent">> = async (context) =>
    await getServerSidePropsWithDefaultSanityContent(config(), context, ["penaltiesModalContent"])

export default Guests
